// removed by extract-text-webpack-plugin
module.exports = {"buttonSection":"UpKkW","img":"_3KBZE"};